import { ReactNode } from 'react';
import { SectionHeader, SectionHeaderProps } from '../../SectionHeader';

export interface FootnoteContainerProps extends Pick<SectionHeaderProps, 'header'> {
  children: ReactNode;
  footnoteChar: string;
}

export default ({ children, header, footnoteChar }: FootnoteContainerProps) => {
  return (
    <div className="bg-darkMode-gray-medium/[0.16] rounded-lg mx-3 pb-3 mt-6">
      <div className="flex items-center mx-4">
        <div className="mr-3 grid place-content-center h-5 w-5 overflow-hidden rounded-full bg-palette-600">
          <p className="text-sm leading-none font-bold text-palette-1100">{footnoteChar}</p>
        </div>
        <SectionHeader header={header} />
      </div>
      {children}
    </div>
  );
};
